import { ApplicationConfig, CSP_NONCE, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation, withRouterConfig } from '@angular/router';
import Aura from '@primeuix/themes/aura'; // Or your chosen theme
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from '@azure/msal-browser';
import {
  MsalInterceptor,
  MSAL_INSTANCE,
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';
import { EnvironmentProvider } from './providers/environment.provider';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { TokenInterceptor } from './providers/token-interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideTheme } from 'tmna-mqcs-ui/src/lib/services/init/utils';

export function MSALInstanceFactory(): IPublicClientApplication {
  const environmentProvider = inject(EnvironmentProvider);
  return new PublicClientApplication({
    auth: {
      clientId: environmentProvider.environment.CLIENT_ID,
      authority: environmentProvider.environment.TENANT_ID,
      redirectUri: '/', //environment.REDIRECT_URL,
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const environmentProvider = inject(EnvironmentProvider);
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environmentProvider.environment.apiConfig.uri,
    environmentProvider.environment.apiConfig.scopes
  );
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  const environmentProvider = inject(EnvironmentProvider);
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read', environmentProvider.environment.API_SCOPE],
    },
    loginFailedRoute: '/login-failed',
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    // provideAppInitializer(() => {
    //   const environmentProvider = inject(EnvironmentProvider);
    //   return environmentProvider.init();
    // }),
    provideAnimations(), provideAnimationsAsync("animations"),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    { provide: CSP_NONCE, useValue: 'J9rJhgwxlxL1PBI3rMbtzTvUWwxya1ZH' },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideTheme(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme'
        }
      },
      csp: {
        nonce: 'J9rJhgwxlxL1PBI3rMbtzTvUWwxya1ZH'
      },
      ripple: true
    }),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    ConfirmationService,
    MessageService
  ]
};